import { fetchApi } from '../utils/helpers';
import constants from '../constants';

const {
  FETCH_ENTRIES_REQUEST,
  FETCH_ENTRIES_SUCCESS,
  FETCH_ENTRIES_FAILURE,
  CREATE_ENTRY_REQUEST,
  CREATE_ENTRY_SUCCESS,
  CREATE_ENTRY_FAILURE,
  DELETE_ENTRY_REQUEST,
  DELETE_ENTRY_SUCCESS,
  DELETE_ENTRY_FAILURE,
  EDIT_ENTRY_REQUEST,
  EDIT_ENTRY_SUCCESS,
  EDIT_ENTRY_FAILURE,
} = constants;

/**
 * Fetch entries
 */
export const fetchEntriesSuccess = data => ({
  type: FETCH_ENTRIES_SUCCESS,
  payload: {
    entries: data.entries,
  },
});

export const fetchEntriesFailure = () => ({
  type: FETCH_ENTRIES_FAILURE,
});

export const fetchEntriesRequest = () => ({
  type: FETCH_ENTRIES_REQUEST,
});

export const fetchEntries = (token, data) => dispatch => {
  dispatch(fetchEntriesRequest());

  return fetchApi({
    path: '/entries/search',
    method: 'post',
    token,
    body: JSON.stringify(data),
    dispatch,
    cb: fetchEntriesSuccess,
    fb: fetchEntriesFailure,
  });
};

/**
 * Create entry
 */
export const createEntrySuccess = (resolve, data) => dispatch => {
  resolve();

  dispatch({
    type: CREATE_ENTRY_SUCCESS,
    payload: {
      entry: data.entry,
    },
  });
};

export const createEntryFailure = reject => dispatch => {
  reject();

  dispatch({
    type: CREATE_ENTRY_FAILURE,
  });
};

export const createEntryRequest = () => ({
  type: CREATE_ENTRY_REQUEST,
});

export const createEntry = (token, data) => dispatch => {
  dispatch(createEntryRequest());

  return new Promise((resolve, reject) => {
    fetchApi({
      path: '/entries',
      method: 'post',
      token,
      body: JSON.stringify(data),
      dispatch,
      cb: createEntrySuccess.bind(this, resolve),
      fb: createEntryFailure.bind(this, reject),
    });
  });
};

/**
 * Delete entry
 */
export const deleteEntrySuccess = (resolve, data) => dispatch => {
  resolve();

  dispatch({
    type: DELETE_ENTRY_SUCCESS,
    payload: {
      entry: data.entry,
    },
  });
};

export const deleteEntryFailure = reject => dispatch => {
  reject();

  dispatch({
    type: DELETE_ENTRY_FAILURE,
  });
};

export const deleteEntryRequest = () => ({
  type: DELETE_ENTRY_REQUEST,
});

export const deleteEntry = (token, entryId) => dispatch => {
  dispatch(deleteEntryRequest());

  return new Promise((resolve, reject) => {
    fetchApi({
      path: `/entries/${entryId}`,
      method: 'delete',
      token,
      dispatch,
      cb: deleteEntrySuccess.bind(this, resolve),
      fb: deleteEntryFailure.bind(this, reject),
    });
  });
};

/**
 * Edit entry
 */
export const editEntrySuccess = (resolve, data) => dispatch => {
  resolve();

  dispatch({
    type: EDIT_ENTRY_SUCCESS,
    payload: {
      entry: data.entry,
    },
  });
};

export const editEntryFailure = reject => dispatch => {
  reject();

  dispatch({
    type: EDIT_ENTRY_FAILURE,
  });
};

export const editEntryRequest = () => ({
  type: EDIT_ENTRY_REQUEST,
});

export const editEntry = (token, entryId, data) => dispatch => {
  dispatch(editEntryRequest());

  return new Promise((resolve, reject) => {
    fetchApi({
      path: `/entries/${entryId}`,
      method: 'put',
      token,
      body: JSON.stringify(data),
      dispatch,
      cb: editEntrySuccess.bind(this, resolve),
      fb: editEntryFailure.bind(this, reject),
    });
  });
};



// WEBPACK FOOTER //
// ./src/actions/entries.js